import { defineStore } from '#imports';

enum messageType {
  success = 'success',
  error = 'error',
  customerMessage = 'customerMessage',
}

type messageTypeString = keyof typeof messageType

interface NotificationPayloadInterface {
  messageText: string;
  messageType: string | messageTypeString;
}

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notification: {
      messageText: '',
      messageType: '',
    },
    showNewsletterSignup: false,
  }),
  getters: {
    getNotification() : NotificationPayloadInterface {
      return this.notification;
    },
    getShowNewsletterSignup(): boolean {
      return this.showNewsletterSignup;
    }
  },
  actions: {
    setNotification({ messageText, messageType } : NotificationPayloadInterface) {
      this.notification = {
        messageText,
        messageType
      }
    },
    clearNotification() {
      this.setNotification({
        messageText: '',
        messageType: '',
      })
    },
    setShowNewsletterSignup(value : boolean) {
      this.showNewsletterSignup = value
    }
  }
});